import React, { useCallback, useEffect } from 'react';
import Checkbox from '@mui/material/Checkbox';
import { uniqBy } from 'lodash';
import FormGroup from '@mui/material/FormGroup';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import styled from 'styled-components';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import TooltipMui from '@mui/material/Tooltip';

export const CheckboxGroup = ({
  value = [],
  options,
  onChange,
  otherArea = true,
  hideFirstRow = false,
  selectArea = false,
  selectOptions = [],
  hideSecondRow = false,
  otherText = 'Other (please specify):',
}) => {
  /* Analyze initial value for edit */
  const hasData = Array.isArray(value) && value.length > 0;
  //const initSel = (hasData && Number.isInteger(value[0])) ? value : []
  const initSel = hasData && value[0] ? value : [];
  const initText = hasData && typeof value[0] === 'string' ? value[0] : '';
  //const initOther = (hasData && (typeof value[0] === 'string'))

  /* Local state */
  const [sel, setSel] = React.useState(initSel);
  const [other, setOther] = React.useState(false);
  const [notListed, setNotListed] = React.useState(false);
  const [text, setText] = React.useState(initText);
  const [selectVal, setSelectVal] = React.useState('');

  /*useEffect(() => {
    if (value && value.length > 0) {
      if (value.length !== sel.length) {
        const newVal = value[value.length - 1]
        const newValId = options.filter(opt => opt.name === newVal)?.[0]?.id
        if (newValId) {
          const newSel = [...sel]
          newSel.push(newValId)
          setSel(uniqBy(newSel))
        }
      }
    }
  }, [options, sel, value])*/

  useEffect(() => {
    if (options.length > 0) {
      const newSel = [];
      value.forEach?.(val => {
        if (options.map(opt => opt.name).indexOf(val) === -1) {
          setOther(true);
          setText(val);
        }
        const newValId = options.filter(opt => opt.name === val)?.[0]?.id;
        newSel.push(newValId || val);
      });
      setSel(uniqBy(newSel));
    }
  }, [options]);

  const handleChange = useCallback(
    (checked, optId) => {
      let updateSel = [...sel];
      if (checked) {
        updateSel.push(optId);
      } else {
        updateSel = updateSel.filter(prgId => prgId !== optId);
      }
      onChange(updateSel);
      setNotListed(false);
      setSelectVal('');
      setSel(updateSel);
    },
    [onChange, sel],
  );
  const handleOther = ev => {
    const checked = !other;
    if (checked) {
      const crrtValue = [...value].filter(prgId => typeof prgId !== 'string');
      setText('');
      setSel(crrtValue);
      onChange(crrtValue);
    }
    setOther(checked);
  };
  const handleWrite = ev => {
    setText(ev.target.value);
    const crrtValue = [...value];
    let hasString = false;
    crrtValue.forEach((val, i) => {
      if (typeof val === 'string') {
        hasString = true;
        crrtValue[i] = ev.target.value;
      }
    });
    if (!hasString) {
      crrtValue.push(ev.target.value);
    }
    setSel(crrtValue);
    onChange(crrtValue);
  };
  const handleNotListed = ev => {
    setSel([]);
    setNotListed(ev.target.checked);
    if (!selectVal) {
      setSelectVal(selectOptions[0]);
      onChange(selectOptions[0]);
    }
  };
  const handleChooseVal = ev => {
    setSelectVal(ev.target.value);
    onChange(ev.target.value);
  };

  const Wrapper = ({ fully_allocated, children }) => {
    if (fully_allocated) {
      return (
        <Tooltip
          title="This report is fully allocated and cannot accept more donations than it's budget"
          placement="top-start"
          arrow
        >
          {children}
        </Tooltip>
      );
    }
    return children;
  };

  return (
    <FormControl
      component="fieldset"
      style={{ width: '100%', transform: 'translate(-10px)', marginTop: 10 }}
    >
      <FormGroup>
        {options.map(opt => {
          return (
            <Wrapper fully_allocated={opt.fully_allocated}>
              <Item key={opt.id} disabled={opt.fully_allocated}>
                <FormControlLabel
                  control={
                    <Checkbox
                      disabled={opt.fully_allocated}
                      checked={sel.indexOf(opt.id) > -1}
                      onChange={event =>
                        handleChange(event.target.checked, opt.id)
                      }
                      color="primary"
                    />
                  }
                  label={
                    <>
                      {!hideFirstRow && (
                        <span
                          className={`${
                            hideSecondRow ? 'pdt10 regular-3' : 'title-5'
                          }`}
                        >
                          {opt.name}
                        </span>
                      )}
                      {!hideSecondRow && (
                        <span
                          className={`regular-3 ${hideFirstRow ? 'pdt10' : ''}`}
                        >
                          {opt.period}
                        </span>
                      )}
                    </>
                  }
                />
              </Item>
            </Wrapper>
          );
        })}
        {/* other area */}
        {otherArea && (
          <React.Fragment>
            <Item>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={other}
                    onChange={handleOther}
                    color="primary"
                  />
                }
                label={otherText}
              />
            </Item>
            {other && (
              <Item>
                <Input value={text} placeholder="" onChange={handleWrite} />
              </Item>
            )}
          </React.Fragment>
        )}
        {/* other area END */}

        {/* select */}
        {selectArea && (
          <React.Fragment>
            <Item>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={notListed}
                    onChange={handleNotListed}
                    color="primary"
                  />
                }
                label="Not listed"
              />
            </Item>
            {notListed && (
              <Item>
                <Selector
                  native
                  value={selectVal}
                  onChange={handleChooseVal}
                  inputProps={{
                    name: 'age',
                    id: 'filled-age-native-simple',
                  }}
                >
                  {selectOptions.map(y => (
                    <option value={y}>{y}</option>
                  ))}
                </Selector>
              </Item>
            )}
          </React.Fragment>
        )}
        {/* select END */}
      </FormGroup>
    </FormControl>
  );
};

const Item = styled.div`
  width: 100%;
  display: flex;
  height: auto;
  flex-direction: row;
  margin-bottom: 10px;
  background-color: ${props => (props.disabled ? '#f1f1f1' : 'transparent')};
  cursor: pointer;
  .MuiInputBase-root {
    width: 100%;
    select {
      background-color: #ffffff;
    }
  }
`;

const Input = styled(TextField).attrs({
  fullWidth: true,
})`
  background-color: #ffffff !important;
  margin-top: 0px !important;
  .Mui-disabled {
    background-color: #f1f1f1 !important;
  }
  input {
    padding-left: 60px;
    padding-right: 60px;
  }
  fieldset {
    border-radius: 4px;
    width: calc(100% - 80px);
    left: 40px;
  }
`;

const Selector = styled(Select)`
  width: 100% !important;
  margin-left: 40px;
  svg.MuiSvgIcon-root.MuiSelect-icon {
    right: 10px !important;
  }
`;

export const Tooltip = styled(TooltipMui)``;
